"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNotesSchema = exports.FACE_VALUE_MAX = exports.VALUATION_CAP_MAX = exports.INTEREST_RATE_MAX = exports.DISCOUNT_RATE_MAX = void 0;
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
exports.DISCOUNT_RATE_MAX = "Discount rate can not exceed 100.00%";
exports.INTEREST_RATE_MAX = "Interest rate can not exceed 100.00%";
exports.VALUATION_CAP_MAX = "Valuation cap can not exceed $99,999,999,999.99";
exports.FACE_VALUE_MAX = "Face value can not exceed $1,000,000.00";
exports.CreateNotesSchema = yup.object().shape({
    type: yup.string().required("Please select Type"),
    name: yup
        .string()
        .trim("Name can not be empty")
        .required("Name can not be empty")
        .matches(constants_1.ALPHANUMERIC_REGEX_WITH_SPACE, "Name can only contain letters, numbers and spaces")
        .min(2, "Name should be at least 2 characters")
        .max(20),
    code: yup
        .string()
        .required("Code can not be empty")
        .matches(constants_1.ALPHANUMERIC_REGEX, "Code can only contain letters and numbers")
        .min(2, "Code should be at least 2 characters")
        .max(4, "Code can not exceed 4 characters"),
    faceValue: yup.lazy((faceValue) => faceValue === undefined || faceValue === ""
        ? yup.string().required("Face value can not be empty")
        : yup
            .number()
            .min(0.01, "Face value should be at least $0.01")
            .when("$isDollar", ([isDollar], schema) => isDollar ? schema.max(1000000.0, exports.FACE_VALUE_MAX) : schema.max(100000000.0, exports.FACE_VALUE_MAX))),
    shareClassId: yup
        .string()
        .when("type", ([type], schema) => type === "convertible" ? schema.required("Please select a Share class") : schema.notRequired()),
    durationType: yup
        .string()
        .when(["$isDollar", "type"], ([isDollar, type], schema) => type === "convertible" && isDollar ? schema.required("Please select") : schema.notRequired()),
    duration: yup.lazy((duration) => duration === undefined || duration === ""
        ? yup
            .string()
            .when("type", ([type], schema) => type === "convertible" ? schema.required("Duration is required") : schema.notRequired())
        : yup
            .number()
            .when("type", ([type], schema) => type === "convertible"
            ? schema.required("Duration is required").min(1, "Invalid").positive("Invalid").integer("Invalid")
            : schema.positive("Invalid").min(0).notRequired())),
    interestRate: yup.lazy((interestRate) => interestRate === undefined || interestRate === ""
        ? yup
            .string()
            .when("type", ([type], schema) => type === "convertible" ? schema.required("Interest rate can not be empty") : schema.notRequired())
        : yup
            .number()
            .min(0.0, "Interest rate should be at least be 0.00")
            .when("$isDollar", ([isDollar], schema) => isDollar ? schema.max(100.0, exports.INTEREST_RATE_MAX) : schema.max(10000.0, exports.INTEREST_RATE_MAX))),
    valuationCap: yup.lazy((valuationCap) => valuationCap === undefined || valuationCap === ""
        ? yup.string().notRequired()
        : yup
            .number()
            .min(0.01, "Valuation cap should be at least $0.01")
            .when("$isDollar", ([isDollar], schema) => isDollar ? schema.max(99999999999.99, exports.VALUATION_CAP_MAX) : schema.max(9999999999999.99, exports.VALUATION_CAP_MAX))),
    discountRate: yup.lazy((discountRate) => discountRate === ""
        ? yup.string().notRequired()
        : yup
            .number()
            .min(0.0, "Discount rate should be at least be 0.00")
            .when("$isDollar", ([isDollar], schema) => isDollar ? schema.max(100.0, exports.DISCOUNT_RATE_MAX) : schema.max(10000.0, exports.DISCOUNT_RATE_MAX))),
});
//# sourceMappingURL=CreateNotesSchema.js.map